import { Doc } from '@dadohr/shared/domainTypes/document';
import {
  Feature,
  FeatureMap,
  FEATURES,
  IFeature,
  IFeatureStatus,
  isFeatureEnabled,
  setFeature as setFeature_
} from '@dadohr/shared/domainTypes/features';
import { IOrganization } from '@dadohr/shared/domainTypes/org';
import { partition } from 'lodash';
import { batchUpdateDocs, updateDoc } from '../../../../services/firebase';

export interface IFeatureListItem {
  name: Feature;
  feature: IFeature;
  enabled: boolean;
  status: IFeatureStatus | null;
}

export interface IFeatureDashboardListItem {
  name: Feature;
  feature: IFeature;
  orgs: {
    enabled: Doc<IOrganization>[];
    disabled: Doc<IOrganization>[];
  };
  counts: {
    total: number;
    enabled: number;
  };
}

export const getFeatureList = (featureMap: FeatureMap): IFeatureListItem[] => {
  return Object.keys(FEATURES).map((key) => {
    const name = key as Feature;
    const feature = FEATURES[name];
    return {
      name,
      feature,
      enabled: isFeatureEnabled(featureMap, name),
      status: featureMap[feature.dbKey] || null
    };
  });
};

export const getDashboardData = (
  orgs: Doc<IOrganization>[]
): IFeatureDashboardListItem[] => {
  const total = orgs.length;
  return Object.keys(FEATURES).map((key) => {
    const name = key as Feature;
    const feature = FEATURES[name];
    const [enabled, disabled] = partition(orgs, (o) =>
      isFeatureEnabled(o.data.features, name)
    );
    return {
      name,
      feature,
      orgs: {
        enabled,
        disabled
      },
      counts: {
        total,
        enabled: enabled.length
      }
    };
  });
};

export const setFeature = (
  org: Doc<IOrganization>,
  feature: Feature,
  enabled: boolean
) => {
  return updateDoc(org, (o) => ({
    features: setFeature_(o.features, feature, enabled, 'EMPLEXP')
  }));
};

export const setFeatureForOrgs = (
  orgs: Doc<IOrganization>[],
  feature: Feature,
  enabled: boolean
) => {
  return batchUpdateDocs(orgs, (o) => ({
    features: setFeature_(o.features, feature, enabled, 'EMPLEXP')
  }));
};
